export default __webpack_public_path__ + "static/media/instagram_orange.cfb26122.svg";